export default class ManageErrorMessages {
	constructor({that, message, title}) {
		this.that = that;
		this.errorMessage = message || that.$t("ErrorMessage");
		this.title = title || that.$t("ErrorTitle");
	}

	setTitle(title) {
		this.title = title;
	}

	setErrorMessage(errorMessage) {
		const errors = {
			"auth/wrong-password": this.that.$t("Login.ValidMessages.InvalidPassword"),
			"auth/user-not-found": this.that.$t("Login.ValidMessages.UserNotFound"),
			"auth/too-many-requests": this.that.$t("Login.ValidMessages.TooManyRequests"),
			"Resource are empty": this.that.$t("Login.ValidMessages.UserNotFound"),
			"Resource is not ACTIVE": this.that.$t("Login.Disabled"),
			"type file not valid": this.that.$t("UploadFiles.InvalidFormatFile"),
			"storage/unauthorized": this.that.$t("Zonification.UploadZones.Error.Permission"),
			"storage/canceled": this.that.$t("Zonification.UploadZones.Error.Cancel"),
			"storage/unknown": this.that.$t("Zonification.UploadZones.Error.Unknown"),
			"The cell_phone already registered for this company.": this.that.$t(
				"CreatePasswordVP.CellphoneAlreadyRegister"
			),
			"The cell_phone sent does not meet the characteristics of an cell_phone.": this.that.$t(
				"CreatePasswordVP.CellphoneNoValid"
			),
			"The visit_point_id already registered.": this.that.$t("CreatePasswordVP.VisitPointAlreadyRegister"),
		};
		this.errorMessage = errors[errorMessage] ? errors[errorMessage] : this.that.$t("Error");
	}

	showMessage() {
		this.that.$vs.notify({
			time: 7000,
			title: this.title,
			text: this.errorMessage,
			iconPack: "feather",
			icon: "icon-alert-circle",
			color: "danger",
		});
	}

	processError(err) {
		let text = this.that.$t("ErrorMessage");
		if (err.message === "missing fields: ['address']") {
			text = this.that.$t("VisitPointObject.Create.ErrorFindAddress.Text");
		}
		if (err.message === "Not georreferencer address") {
			text = this.that.$t("ManualData.AddressCouldBeNotGeoreferenced");
		}
		if (err.data) {
			if (err.data.reason === "Sitidata api georeversed token not enabled for this company.") {
				text = this.that.$t("ManualData.SitidataGeoreverseToken");
			} else if (err.data.reason === "Sitidata api not enabled for this company.") {
				text = this.that.$t("MapModule.SitidataNoEnabled");
			}
		}
		this.that.$vs.notify({
			color: "danger",
			title: this.that.$t("MapModule.Georeferencer"),
			text,
			time: 5000,
		});
	}
}
